import {NameSpace} from "../../../utils/consts/file";

export const getAppStatus = (state) => state[NameSpace.App].appStatus;